window.Products.Clothing.KimonoRobe = function() {
};
window.Products.Clothing.KimonoRobe.inherits(window.Products.Clothing.Clothing);

window.Products.Clothing.KimonoRobe.id = 43;
window.Products.Clothing.KimonoRobe.slug = 'kimono-robe';
window.Products.Clothing.KimonoRobe.has_3d = true;
window.Products.Clothing.KimonoRobe.dpi = 150;

window.Products.Clothing.KimonoRobe.prototype.set3dProperties = function(modelViewer) {
	this.updateThreeTexture(modelViewer);
	modelViewer.object.position.x = -0.1;
	modelViewer.object.position.y = -1.62;
	modelViewer.setFixedView('front');
	if(!modelViewer.inlab){
		modelViewer.enableAutoRotate(0.5);
	}
};

window.Products.Clothing.KimonoRobe.prototype.setThreeControls = function(controls) {
	controls.minDistance = 2.8;
	controls.maxDistance = 3.5;
};

window.Products.Clothing.KimonoRobe.prototype.updateThreeTexture = function(modelViewer) {
	modelViewer.object.children[1].material.map = modelViewer.texture;
	modelViewer.object.children[2].material.map = modelViewer.texture;
};